module.exports = __webpack_public_path__ + "static/pompkiller-a09e6eec69abca3dd641dc149a8a64d0.jpg";